import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IUserDataInitializationService = ( createDecorator('IUserDataInitializationService'));
export { IUserDataInitializationService };
